import { render, staticRenderFns } from "./QuizTeacherAreaExpertise.vue?vue&type=template&id=57682156&"
import script from "./QuizTeacherAreaExpertise.vue?vue&type=script&lang=js&"
export * from "./QuizTeacherAreaExpertise.vue?vue&type=script&lang=js&"
import style0 from "./QuizTeacherAreaExpertise.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports